import React from 'react'

import {
  CellsTitle,
  CellHeader,
  CellBody,
  CellFooter,
  CellsTips,
  Form,
  FormCell,
  Icon,
  Input,
  Label,
  Select
} from 'react-weui'

import phoneCodes from '../../phoneCodes'

const PersonalForm = (props) => (
  <div>
    <CellsTitle>个人信息</CellsTitle>
    <Form>
      <FormCell warn={props.nameError}>
        <CellHeader>
          <Label>姓名</Label>
        </CellHeader>
        <CellBody>
          <Input
            type="text"
            placeholder="张先生"
            value={props.name}
            onChange={evt => props.onName(evt.target.value)}
          />
        </CellBody>
        <CellFooter>
          <Icon value="warn" />
        </CellFooter>
      </FormCell>
      <FormCell select selectPos="before" warn={props.phoneError}>
        <CellHeader>
          <Select
            onChange={evt => props.onPrefix(evt.target.value)}
          >
            {
              [
                { key: "c86",  code: "+86",  paren: "中国" },   // china
                { key: "c852", code: "+852", paren: "香港" },   // hk
                { key: "c886", code: "+886", paren: "台湾" },   // taiwan
                { key: "c34",  code: "+34",  paren: "西班牙" }, // spain
              ].map(({code, paren, key}) => (
                <option selected={props.prefix == code} key={key} value={code}>{code} ({paren})</option>
              ))
            }
            <option disabled>──────────</option>
            {
              phoneCodes.map(x => <option key={x} value={x}>{x}</option>)
            }
          </Select>
        </CellHeader>
        <CellBody>
          <Input
            type="number"
            placeholder="输入手机号"
            value={props.phone}
            onChange={evt => props.onPhone(evt.target.value)}
          />
        </CellBody>
        <CellFooter>
          <Icon value="warn" />
        </CellFooter>
      </FormCell>
      <FormCell warn={props.emailError}>
        <CellHeader>
          <Label>电邮</Label>
        </CellHeader>
        <CellBody>
          <Input
            type="text"
            placeholder="张先生"
            value={props.email}
            onChange={evt => props.onEmail(evt.target.value)}
          />
        </CellBody>
        <CellFooter>
          <Icon value="warn" />
        </CellFooter>
      </FormCell>
    </Form>

    {
      props.includeWarning && (
        <CellsTips>⚠️ Recuerda usar un contacto que puedas recibir en este momento!</CellsTips>
      )
    }
  </div>
)

export default PersonalForm



// WEBPACK FOOTER //
// ./src/app/catalogo/components/PersonalForm.jsx